// Autogenerated from `packages/@members/copy/models.generated/__model__.ts.hbs`

export const Language = {
  AllLanguagesCTA: 'allLanguagesCTA',
  SelectLanguage: 'selectLanguage',
} as const;
